//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.UploadFileMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.UploadFileMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.UploadFileMutationSelections
import com.wintermar.inspection.graphql.type.FileUploadCommandInput
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class UploadFileMutation(
  public val command: FileUploadCommandInput,
) : Mutation<UploadFileMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    UploadFileMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = UploadFileMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = UploadFileMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(UploadFileMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val uploadFile: UploadFile,
  ) : Mutation.Data

  public data class UploadFile(
    public val fileName: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "a12005109c710f6c83fd0d13f5c75476810126f4a9a7ca5a8399609336dd3bea"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation uploadFile($command: FileUploadCommandInput!) {
     *   uploadFile(command: $command) {
     *     fileName
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation uploadFile(${'$'}command: FileUploadCommandInput!) { uploadFile(command: ${'$'}command) { fileName } }"

    public const val OPERATION_NAME: String = "uploadFile"
  }
}
